import { InjectionToken, Signal } from '@angular/core'
import { CookieAuthConfiguration, OidcAuthConfiguration } from 'environments/environment.model'

export interface AuthUserProfile {
  displayName: string
  email: string
  initials: string
}

export interface AppAuthService {
  readonly isAuthenticated: Signal<boolean | undefined>
  readonly userProfile: Signal<AuthUserProfile | undefined>
  readonly expirationDateTime: Signal<Date | undefined>

  login(): void
  logout(): void
  isLoggedIn(): Promise<boolean>
  getAccessToken(): string | null
}

export const AuthService = new InjectionToken<AppAuthService>('AuthService')
export const OIDC_AUTH_CONFIG = new InjectionToken<OidcAuthConfiguration>('OIDC_AUTH_CONFIG')
export const COOKIE_AUTH_CONFIG = new InjectionToken<CookieAuthConfiguration>('COOKIE_AUTH_CONFIG')
